var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6206 12.0801H13.647C14.9663 12.0801 15.7319 11.3145 15.7319 9.85156V2.29785C15.7319 0.834961 14.9595 0.0693359 13.4829 0.0693359H2.45654C1.1372 0.0693359 0.371578 0.828125 0.371578 2.29785V9.85156C0.371578 11.3145 1.14404 12.0801 2.6206 12.0801ZM7.28271 6.31055L2.30615 1.38867C2.40185 1.36816 2.51123 1.35449 2.62744 1.35449H13.4761C13.5991 1.35449 13.7085 1.36816 13.811 1.39551L8.8413 6.31055C8.5542 6.59082 8.31494 6.71387 8.06201 6.71387C7.80908 6.71387 7.56982 6.58398 7.28271 6.31055ZM1.6499 2.39355L5.36865 6.05078L1.6499 9.72852V2.39355ZM10.7554 6.05078L14.4536 2.41406V9.71484L10.7554 6.05078ZM2.62744 10.7881C2.50439 10.7881 2.38818 10.7744 2.28564 10.7539L6.20263 6.87109L6.57177 7.24023C7.0708 7.72559 7.54931 7.93066 8.06201 7.93066C8.56787 7.93066 9.05322 7.72559 9.54541 7.24023L9.92138 6.87109L13.8315 10.7471C13.7222 10.7744 13.606 10.7881 13.4761 10.7881H2.62744Z",
    fill: "#B2B2BF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-email.d509440801933fe3c57a06e596ef5bcf.svg";